import { ShowerHead, Gauge, Droplets, Fan } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const PAINS = [
  {
    icon: ShowerHead,
    title: "Água quente que não funciona",
    desc: "Problemas no aquecedor ou no sistema de aquecimento podem comprometer o conforto e exigir uma avaliação técnica.",
  },
  {
    icon: Gauge,
    title: "Pressão de água insuficiente",
    desc: "Quando a água chega com pouca força às torneiras e aos chuveiros, pode ser necessário avaliar a instalação, a pressurização ou o sistema de bombeamento.",
  },
  {
    icon: Droplets,
    title: "Caixa-d'água que não enche",
    desc: "Falhas no abastecimento podem estar relacionadas a diferentes componentes do sistema hidráulico e precisam ser avaliadas conforme cada instalação.",
  },
  {
    icon: Fan,
    title: "Problemas em bombas ou instalações hidráulicas",
    desc: "Motobombas, tubulações e sistemas de recalque podem exigir manutenção, reparo ou adequação técnica.",
  },
];

export default function Problema() {
  return (
    <section id="problema" data-testid="hidropro-problem-section" className="relative py-16 md:py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHead
          index="01"
          label="O problema"
          title="Quando o sistema falha, sua rotina sente."
          lead="Problemas hidráulicos podem comprometer o abastecimento de água, a pressão e o funcionamento dos equipamentos. A avaliação técnica ajuda a identificar a causa e definir a solução adequada para cada instalação."
        />

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:mt-16 lg:grid-cols-4">
          {PAINS.map((pain, i) => (
            <Reveal key={pain.title} delay={i * 0.08} className="h-full">
              <article className="group flex h-full flex-col rounded-xl border border-[rgba(10,92,140,0.14)] bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:border-[#0A5C8C]/45 hover:shadow-[0_18px_40px_rgba(10,92,140,0.14)]">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-[#D97706]/10 text-[#D97706] transition-colors duration-300 group-hover:bg-[#D97706] group-hover:text-white">
                  <pain.icon className="h-5 w-5" />
                </span>
                <h3 className="mt-5 font-display text-lg font-bold tracking-tight text-[#1A1A1A]">{pain.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{pain.desc}</p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-12 max-w-3xl border-l-[3px] border-[#0A5C8C] pl-6 font-display text-lg font-semibold leading-snug text-[#1A1A1A] sm:text-xl lg:mt-16">
            Está enfrentando algum desses problemas? Entre em contato com a HidroPro Serviços Técnicos e consulte as
            possibilidades de atendimento.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
